// extracted by mini-css-extract-plugin
module.exports = {"root":"invitationSummary_root___o16W","date":"invitationSummary_date__YbeWk"};